import { useEffect, useState } from 'react'

export type IframeAttributes = {
  src?: string
  height?: string
  title?: string
  allow?: string
  name?: string
}
const Iframe = (props: IframeAttributes | undefined): JSX.Element => {
  const [attributes, setAttributes] = useState<IframeAttributes | undefined>()

  useEffect(() => {
    setAttributes(props)
  }, [props])

  const style: React.CSSProperties = {
    border: 'none',
    display: 'block',
    width: '100%',
    padding: 0,
    margin: 0,
    flex: 1
  }

  return <iframe {...attributes} height={props?.height} style={style} />
}

export default Iframe
